import { createStore } from 'satcheljs';
var initialInlineImageStore = {
    inlineImages: {},
};
var store = createStore('inlineimages', initialInlineImageStore)();
export default store;
//# sourceMappingURL=store.js.map